import { z } from 'my-zod'
import { commentModel } from './comment-model'

export const createCommentSystemRequest = commentModel.omit({
  userId: true,
  profileId: true,
  createdDate: true,
  lastModifiedDate: true,
  deletedDate: true,
  pinned: true
})

export type createCommentSystemRequest = z.infer<typeof createCommentSystemRequest>
